import { __decorate, __metadata } from "tslib";
import { ArrayMaxSize, ArrayUnique, IsEmail, IsOptional, IsUUID } from 'class-validator';
import { IS_EMAIL_DEFAULT_OPTIONS } from '../../shared/validator';
import { MAX_DISTRIBUTION_EMAILS } from '../../type/order';
/**
 * A request for some part of the court record or live stream
 */
export class LineItemRequest {
    constructor(locationId, departmentId, distributionList) {
        this.locationId = locationId;
        this.departmentId = departmentId;
        this.distributionList = distributionList;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], LineItemRequest.prototype, "locationId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], LineItemRequest.prototype, "departmentId", void 0);
__decorate([
    ArrayUnique(),
    ArrayMaxSize(MAX_DISTRIBUTION_EMAILS),
    IsEmail(IS_EMAIL_DEFAULT_OPTIONS, { each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], LineItemRequest.prototype, "distributionList", void 0);
